import { Reveal, SectionHeading } from "./Reveal";
import { PhoneCall, FileText } from "lucide-react";

export default function Modalites() {
  return (
    <section id="modalites" data-testid="modalites-section" className="relative py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeading
          overtitle="Modalités"
          title="Commencer, simplement."
          align="center"
        />
        <div className="mt-16 grid md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          <Reveal>
            <div
              data-testid="modalites-free-card"
              className="relative h-full rounded-2xl border border-[#D4AF37]/40 bg-[#111C33] p-8 lg:p-10 overflow-hidden"
            >
              <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-[#D4AF37]/15 blur-3xl" />
              <PhoneCall size={26} className="text-[#D4AF37]" strokeWidth={1.5} />
              <h3 className="font-serif-display mt-5 text-2xl text-white">Premier rendez-vous : le diagnostic</h3>
              <p className="mt-3 text-sm sm:text-base text-slate-400 leading-relaxed">
                Un premier échange offert et sans engagement pour poser votre situation, établir
                ensemble votre besoin réel — et son degré d'urgence — puis décider de la suite.
              </p>
              <p className="font-mono-accent mt-6 text-xs uppercase tracking-[0.25em] text-[#F3E5AB]">
                Offert · Sans engagement · Visio ou présentiel
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div
              data-testid="modalites-quote-card"
              className="h-full rounded-2xl border border-[#D4AF37]/15 bg-[#0C1526] p-8 lg:p-10"
            >
              <FileText size={26} className="text-[#D4AF37]" strokeWidth={1.5} />
              <h3 className="font-serif-display mt-5 text-2xl text-white">Ensuite, sur mesure</h3>
              <p className="mt-3 text-sm sm:text-base text-slate-400 leading-relaxed">
                Chaque accompagnement — dirigeant, entreprise ou individuel — fait l'objet d'un
                cadre et d'un devis personnalisés, adaptés à vos objectifs réels.
              </p>
              <p className="font-mono-accent mt-6 text-xs uppercase tracking-[0.25em] text-slate-400">
                Sur devis · En présentiel ou à distance
              </p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <div data-testid="modalites-durations" className="mt-6 flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
            {["Séance individuelle — 1h", "Séance en entreprise — 1h30", "En visio ou en présentiel"].map((chip) => (
              <span key={chip} className="rounded-full border border-[#D4AF37]/25 bg-[#111C33]/60 px-5 py-2.5 text-xs sm:text-sm text-slate-300">
                {chip}
              </span>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.25} className="text-center">
          <a
            data-testid="modalites-cta-button"
            href="https://calendly.com/contact-frederiquevasseur/diagnostic-offert"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-12 rounded-full bg-[#D4AF37] px-10 py-4 text-sm font-semibold text-[#0A1120] transition-all duration-300 hover:bg-[#F3E5AB] hover:-translate-y-0.5 hover:shadow-[0_12px_40px_-10px_rgba(212,175,55,0.5)]"
          >
            Réserver mon diagnostic offert
          </a>
        </Reveal>
      </div>
    </section>
  );
}
